import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-society',
  templateUrl: './add-society.component.html',
  styleUrls: ['./add-society.component.scss']
})
export class AddSocietyComponent implements OnInit {
  societyForm: FormGroup;
  isLoading: boolean;
  districtList: any;
  DistrictList: any;
  UserID: any;
  submitted: boolean = false;

  constructor(private fb: FormBuilder, 
    private gs: GeneralService, 
    public dialogRef: MatDialogRef<AddSocietyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.UserID = data.UserID
     }

  ngOnInit() {
    this.societyForm = this.fb.group({
      societyname: new FormControl(null,[Validators.required,Validators.pattern('^[A-Za-z0-9\-/a ]+$')]),
      VillageID:new FormControl(null,Validators.required),
      districtid :new FormControl(null),
      villageid: new FormControl(null),
      talukaid:new FormControl(null),
    });
    this.getDistrict();
  }
  selectEvent(item:any){
    console.log("item",item)
    this.societyForm.controls.villageid.setValue(item.villageid)
    this.societyForm.controls.talukaid.setValue(item.TalukaID)
    this.societyForm.controls.districtid.setValue(item.DistrictID)
    this.societyForm.controls.VillageID.setValue(item.area)
  }
  onSubmit(){
    this.submitted = true;
    if(this.societyForm.valid){
      this.societyForm.removeControl('VillageID')
      this.societyForm.controls.societyname.setValue(this.societyForm.controls.societyname.value.trim());
      this.gs.addSociety(this.societyForm.value)
      .subscribe((res) => {
        this.isLoading = false;
        if(res.status == 200){
          Swal.fire({
            position: 'top-end',
            type: 'success',
            title: res.message,
            showConfirmButton: false,
            timer: 1500          
          });
          this.onConfirmClick(true);
        }
         else {
          Swal.fire({
            position: 'top-end',
            text: res.massage,
            type: "info",
            timer: 1500  
          });
          // this.isLoading = false;
          this.onConfirmClick();
        }
      },(error) => {                             
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: error.message,
          type: "error",
        });
        this.onConfirmClick();
       }
      );
    }else{
      this.isLoading=false
      return;
    }
  }
  get f() { return this.societyForm.controls; }
  getDistrict(){
    this.gs.getDistrictlist(this.UserID).subscribe((res:any)=>{
      this.DistrictList = res.data
      console.log('jdvsodv',this.DistrictList)
    
    })
  }
  onConfirmClick(result?): void {
    if(result){
      this.dialogRef.close(true);
    }
    else{
      this.dialogRef.close();
    }
  }

}
